import { render, staticRenderFns } from "./extended-filter.vue?vue&type=template&id=d87d58c6&scoped=true&"
import script from "./extended-filter.ts?vue&type=script&lang=ts&"
export * from "./extended-filter.ts?vue&type=script&lang=ts&"
import style0 from "./extended-filter.scss?vue&type=style&index=0&id=d87d58c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d58c6",
  null
  
)

export default component.exports